import { z } from 'zod';
/**
 * Dienstplan (ADR-041): Erwachsene tragen pro Tag eine Schicht ein; „Übernahme"
 * erzeugt Kalendertermine (pflegender User = Teilnehmer mit 2-h-Erinnerung, alle
 * anderen nur Info). Feste Schicht-Typen mit lokalen (Europe/Berlin) Zeiten;
 * zusätzlich Abwesenheiten TU (Urlaub, ganztägig, zählt 5 Std.) und K (krank,
 * ganztägig, 0 Std.).
 */
export const SHIFT_CODES = ['FD_T', 'LFD_T', 'SD_T', 'FSD_T', 'FD_C', 'SD_C', 'TU', 'K'];
// Uhrzeiten = Anwesenheit (Kalender-Block); hours = angerechnete Netto-Stunden.
export const SHIFT_TYPES = [
    { code: 'FD_T', label: 'FD/T', start: '05:15', end: '13:00', hours: 6.5, absence: false, title: 'Frühdienst/Treis' },
    { code: 'LFD_T', label: 'LFD/T', start: '05:15', end: '13:00', hours: 7.5, absence: false, title: 'Langer Frühdienst/Treis' },
    { code: 'SD_T', label: 'SD/T', start: '09:30', end: '15:00', hours: 5, absence: false, title: 'Spätdienst/Treis' },
    { code: 'FSD_T', label: 'FSD/T', start: '08:00', end: '15:00', hours: 6, absence: false, title: 'Früher Spätdienst/Treis' },
    { code: 'FD_C', label: 'FD/C', start: '07:30', end: '14:00', hours: 6, absence: false, title: 'Frühdienst/Cochem' },
    { code: 'SD_C', label: 'SD/C', start: '13:00', end: '20:00', hours: 6, absence: false, title: 'Spätdienst Cochem' },
    { code: 'TU', label: 'TU', start: '00:00', end: '00:00', hours: 5, absence: true, title: 'Urlaub' },
    { code: 'K', label: 'K', start: '00:00', end: '00:00', hours: 0, absence: true, title: 'Krank' },
];
/** Schicht-Definition zum Code. */
export const shiftDef = (code) => SHIFT_TYPES.find((s) => s.code === code);
/** Angerechnete Arbeitsstunden einer Schicht (Abwesenheit = 0). */
export const shiftHours = (code) => shiftDef(code).hours;
/** Gesamte Arbeitsstunden über mehrere Codes. */
export const totalShiftHours = (codes) => codes.reduce((sum, c) => sum + shiftHours(c), 0);
/** „7,75 h" (deutsche Kommaschreibweise, ohne unnötige Nachkommastellen). */
export const formatHours = (h) => `${h.toFixed(2).replace(/\.?0+$/, '').replace('.', ',')} h`;
/** Kennzahlen eines Monats: Arbeitsstunden, Anzahl Dienste, Urlaub, Krank. */
export function shiftSummary(codes) {
    return {
        hours: totalShiftHours(codes),
        dienste: codes.filter((c) => !shiftDef(c).absence).length,
        urlaub: codes.filter((c) => c === 'TU').length,
        krank: codes.filter((c) => c === 'K').length,
    };
}
const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum als YYYY-MM-DD');
export const shiftPlanEntryDtoSchema = z.object({
    date: z.string(), // YYYY-MM-DD
    code: z.enum(SHIFT_CODES),
    eventId: z.string().uuid().nullable(), // gesetzt = bereits in den Kalender übernommen
});
/** Tag setzen (code) oder leeren (code=null). */
export const setShiftSchema = z.object({ date: isoDay, code: z.enum(SHIFT_CODES).nullable() });
/** Monat als YYYY-MM. */
export const shiftMonthSchema = z.object({ month: z.string().regex(/^\d{4}-\d{2}$/, 'Monat als YYYY-MM') });
//# sourceMappingURL=shift.js.map